var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 310 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7138 34.4645L40.4975 1.2482C39.7 0.450734 38.6252 0 37.481 0C36.3368 0 35.2619 0.450734 34.4645 1.2482L1.24821 34.4645C-0.41607 36.1287 -0.41607 38.8332 1.24821 40.4975C2.91249 42.1618 5.65162 42.1618 7.3159 40.4975L9.77764 38.0704V66.1551C9.77764 68.5129 11.65 70.3158 14.0077 70.3158H60.9889C63.3467 70.3158 65.2537 68.5129 65.2537 66.1551V38.0704L67.6807 40.4975C68.5129 41.3296 69.6224 41.7457 70.6973 41.7457C71.7721 41.7457 72.8816 41.3296 73.7138 40.4975C75.378 38.8332 75.378 36.1287 73.7138 34.4645ZM56.5509 61.9944H18.4111V34.9499H56.5509V61.9944ZM21.4276 26.2818L37.481 10.2284L53.5344 26.2818H21.4276Z",
    fill: "#60C3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.912 63.7968C104.504 63.7968 100.273 61.127 100.273 54.1578V34.8105H102.805C108.595 34.8105 110.467 36.4748 110.467 41.8491V52.6322C110.467 55.2673 111.715 56.0648 114.524 56.0648H115.772V59.0813C115.772 62.6179 113.102 63.7968 109.912 63.7968Z",
    fill: "#004B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.907 38.1052C145.035 35.6781 140.424 34.2912 136.332 34.2912C130.334 34.2912 125.931 38.2439 125.931 44.2769C125.931 51.8355 130.542 55.4414 136.54 55.4414C140.493 55.4414 144.896 53.9505 146.734 52.0088H147.011V55.8228C147.011 60.6076 142.227 64.2482 135.015 64.2482C124.89 64.2482 115.771 56.967 115.771 45.2824C115.771 34.4992 123.33 25.5537 135.674 25.5537C142.92 25.5537 147.185 29.1596 147.185 34.3605V38.1745H146.907V38.1052Z",
    fill: "#004B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.002 33.0771C172.046 33.0771 179.293 39.1795 179.293 48.2984C179.293 57.9373 173.433 64.1784 163.274 64.1784C154.849 64.1784 147.983 57.972 147.983 49.2692C147.983 39.4916 154.745 33.0771 164.002 33.0771ZM163.378 41.1212C160.604 41.1212 158.073 44.0683 158.073 48.0904C158.073 53.7766 160.327 56.2384 163.933 56.2384C167.157 56.2384 169.238 53.2912 169.238 49.1999C169.203 43.895 166.915 41.1212 163.378 41.1212Z",
    fill: "#004B5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.262 63.3453C218.854 63.3453 217.605 61.0569 217.605 57.3816V46.4944C217.605 42.6805 216.322 41.2936 213.375 41.2936C210.532 41.2936 209.561 43.3739 209.561 46.3211V63.3106H206.025C201.899 63.3106 199.714 61.9584 199.714 57.3469V46.1824C199.714 42.7152 198.362 41.2589 195.692 41.2589C192.849 41.2589 191.74 42.7152 191.74 46.3558V63.2759H188.203C183.661 63.2759 181.546 61.0916 181.546 57.3123V46.9799C181.546 38.4158 186.469 32.9375 195.866 32.9375C200.477 32.9375 203.944 35.7806 204.915 38.173C206.302 35.9193 209.908 32.9375 214.138 32.9375C222.702 32.9375 227.799 38.0344 227.799 47.2572V63.2759H224.262V63.3453Z",
    fill: "#004B5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.152 64.2121C244.199 64.2121 241.876 62.3745 240.593 60.1901V72.4642H236.883C232.826 72.4642 230.677 70.3144 230.677 65.3216V49.719C230.677 39.1439 236.536 33.0068 246.973 33.0068C255.606 33.0068 262.09 38.8318 262.09 47.9507C262.09 58.0404 256.196 64.2121 248.152 64.2121ZM245.794 40.7735C243.02 40.7735 240.766 43.4433 240.766 47.812C240.766 54.0877 243.436 56.2721 246.938 56.2721C250.163 56.2721 251.931 53.4289 251.931 49.0255C251.896 42.7151 249.989 40.7735 245.794 40.7735Z",
    fill: "#004B5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.677 63.7968C269.268 63.7968 264.587 60.5722 264.587 53.603V23.6807H268.193C272.631 23.6807 274.781 25.7263 274.781 30.7192V52.1121C274.781 54.7472 276.237 55.5447 279.08 55.5447H281.334V59.0813C281.334 62.6526 277.901 63.7968 274.677 63.7968Z",
    fill: "#004B5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.212 55.58C294.96 71.46 292.88 73.0549 286.708 73.0549C283.449 73.0549 280.71 71.2866 280.71 67.9581V65.4963L285.113 65.1843C287.783 64.9762 289.031 63.9014 290.106 61.4743C285.876 55.1639 280.467 41.7457 279.288 33.875H284.593C287.124 33.875 289.724 35.4353 290.314 38.0704C291.319 42.7165 293.365 48.4028 294.925 52.0087C297.11 47.5706 299.433 39.6306 300.057 33.9097H304.946C307.893 33.9097 309.28 35.2966 309.28 37.6543C309.245 40.7402 306.471 49.3043 303.212 55.58Z",
    fill: "#004B5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.2189 36.3018H56.5508V47.0502H65.2189V36.3018Z",
    fill: "url(#paint0_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2292 61.959H35.4004V70.2804H48.2292V61.959Z",
    fill: "url(#paint1_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 63.0679C80.96 73.5043 72.4999 81.9991 62.0288 81.9991C51.5924 81.9991 43.0977 73.539 43.0977 63.0679C43.0977 52.6315 51.5577 44.1367 62.0288 44.1367C72.4999 44.1367 80.96 52.6315 80.96 63.0679Z",
    fill: "#004B5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.9595 75.655C61.0927 75.655 60.2953 75.3083 59.6712 74.7189L51.1764 66.2241C49.9282 64.9759 49.9282 62.9302 51.1764 61.6473C52.4246 60.3991 54.4703 60.3991 55.7532 61.6473L61.9595 67.8537L77.2501 52.5631C78.4983 51.3149 80.544 51.3149 81.8269 52.5631C83.0751 53.8113 83.0751 55.857 81.8269 57.1399L64.2479 74.7189C63.6238 75.343 62.7917 75.655 61.9595 75.655Z",
    fill: "url(#paint2_linear)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6822 72.9499C60.8154 72.9499 60.0179 72.6032 59.3938 72.0138L50.899 63.519C49.6508 62.2708 49.6508 60.2251 50.899 58.9422C52.1473 57.694 54.1929 57.694 55.4758 58.9422L61.6822 65.1486L76.9728 49.858C78.221 48.6098 80.2666 48.6098 81.5495 49.858C82.7977 51.1062 82.7977 53.1519 81.5495 54.4348L63.9706 72.0138C63.3812 72.6032 62.549 72.9499 61.6822 72.9499Z",
    fill: "#60C3AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.093 32.2103C102.146 32.2103 99.7188 29.9566 99.7188 27.1828C99.7188 24.409 102.146 22.1553 105.093 22.1553C108.04 22.1553 110.398 24.409 110.398 27.1828C110.398 29.9566 108.04 32.2103 105.093 32.2103Z",
    fill: "#60C3AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 60.8848,
    y1: 36.311,
    x2: 60.8848,
    y2: 47.0595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 35.4004,
    y1: 66.1289,
    x2: 48.2292,
    y2: 66.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 73.4846,
    y1: 52.4019,
    x2: 59.0254,
    y2: 66.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B8BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5328e95c.svg";
export { ForwardRef as ReactComponent };